import React from "react";
import styles from "./Contact.module.css";
import { Form } from "../Form/Form";
import { BsInstagram, BsFacebook, BsMailbox } from "react-icons/bs";
import { Icons } from "../Icons/Icons";
import yarn from "../assets/yarn-hook.svg";
import dino from "../assets/photos/dino.png";
import paw from "../assets/logo/paw.svg";

function Contact() {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Hablemos</h2>
      <p className={styles.subtitle}>
        ¿Tenés alguna duda? ¿Querés hacerme un encargo totalmente personalizado?
      </p>
      <div className={styles.contact}>
        <Form messageLabel="Tu mensaje" title="Escribe aquí tu mensaje"></Form>
        <div className={styles.images}>
          <img src={paw} className={styles.paw1} alt="paw"></img>
          <img src={paw} className={styles.paw2} alt="paw"></img>
          <img src={paw} className={styles.paw3} alt="paw"></img>
          <img src={dino} alt="contact" className={styles.image}></img>
        </div>
      </div>
      <div className={styles.card}>
        <img src={yarn} alt="yarn" className={styles.yarn}></img>
        <div className={styles.icons}>
          <Icons
            text={"Enviame un DM por Instagram"}
            icon={<BsInstagram></BsInstagram>}
            href="https://www.instagram.com/pawpawneedle/"
            user="pawpawneedle"
          ></Icons>
          <Icons
            text="También podemos hablar por Facebook"
            icon={<BsFacebook></BsFacebook>}
            href="https://www.facebook.com/pawpawneedle"
            user="pawpawneedle"
          ></Icons>
          <Icons
            text="O escribirme directamente a mi mail"
            icon={<BsMailbox></BsMailbox>}
            href="mailto:pawpawneedle@gmail.com"
            user="pawpawneedle"
          ></Icons>
        </div>
      </div>
    </div>
  );
}

export { Contact };
